export function isTruthyAttribute(value: any): boolean {
  return ['1', 'true', true, 1].indexOf(value) !== -1
}
